export function googleMap() {
    const googleMapWrap = document.querySelector('.google-map');
    const googleMap = googleMapWrap.querySelector('#map');
    const lat = googleMap.dataset.lat;
    const lng = googleMap.dataset.lng;
    const markerPin = googleMap.dataset.marker;
    const userMarkerPin = googleMap.dataset.userMarker;
    let zoom = googleMap.dataset.zoom ? +googleMap.dataset.zoom : null;
    let markers = [];
    let markerClusterer = null;

    function initMap() {
        let mapStyle = [
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dedede"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e9e9e9"
                    },
                    {
                        "lightness": 17
                    }
                ]
            }
        ];
        let map = new google.maps.Map(googleMap, {
            styles: mapStyle,
            zoom: zoom || 12,
            maxZoom: 18,
            scrollwheel: false,
            scaleControl: false,
            panControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            overviewMapControl: false,
            fullscreenControl: false,
            center: new google.maps.LatLng(lat || locations[0].lat, lng || locations[0].lng)
        });
        const infoWindow = new google.maps.InfoWindow();

        function initMarkers() {
            //clear markers
            if (markerClusterer) {
                markerClusterer.clearMarkers();
                markers = [];
            }
            //create markers
            markers = locations.map((position, i) => {
                return new google.maps.Marker({
                    position,
                    icon: markerPin
                });
            });
            markerClusterer = new MarkerClusterer(map, markers, {
                styles: [],
                clusterClass: "clustericon",
                imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
            });
        }

        if (typeof locations !== 'undefined') {
            initMarkers();
        } else {
            new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map: map,
                icon: markerPin
            });
        }

        //detect location logic
        const detectLocationButton = document.querySelector('.detect-location button');
        if (detectLocationButton) {
            detectLocationButton.addEventListener("click", () => {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            const pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent();
                            map.setCenter(pos);
                            map.setZoom(12);
                            new google.maps.Marker({
                                position: pos,
                                map,
                                icon: userMarkerPin
                            });

                            const centerCord = new google.maps.LatLng(pos.lat, pos.lng);
                            locations = [];

                            $('.location-item').hide().each(function () {
                                let lat = $(this).attr('data-lat');
                                let lng = $(this).attr('data-lng');

                                let _kCord = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
                                let distance = google.maps.geometry.spherical.computeDistanceBetween(_kCord, centerCord);

                                // miles
                                if (distance * 0.000621371192 < 10) {
                                    $(this).show();
                                    locations.push({lat: parseFloat(lat), lng: parseFloat(lng)});
                                }
                            });

                            if ($('.location-item:visible').length) {
                                $('.locations .no-locations').hide();
                                $('.locations .title-results').text($('.location-item:visible').length + ' location(s) near you').show();

                            } else {
                                $('.locations .title-results').hide();
                                $('.locations .no-locations, .location-item').show();
                            }

                            jcf.replaceAll();
                            initMarkers();

                        },
                        () => {
                            handleLocationError(true, map, infoWindow, map.getCenter());
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, map, infoWindow, map.getCenter());
                }
            });
        }
    }

    function handleLocationError(browserHasGeolocation, map, infoWindow, pos) {
        infoWindow.setPosition(pos);
        infoWindow.setContent(
            browserHasGeolocation
                ? "Error: The Geolocation service failed."
                : "Error: Your browser doesn't support geolocation."
        );
        infoWindow.open(map);
    }

    initMap();
}


// WEBPACK FOOTER //
// ./assets/js/modules/googleMap.js